var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.168 1.86C6.29 3.542 3.483 7.793 2.688 9.709c.608-.001 2.51-.142 5.256-.702 3.434-.7 7.078-2.803 12.474-3.084 4.317-.224 7.03 1.122 7.849 1.822-.07-.63-.813-2.284-3.224-3.854C22.03 1.93 17.264-.242 11.168 1.86z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.217 13.283c-.393 1.065-.164 2.873 0 3.644 1.331 1.33 4.204 1.19 6.447.49 1.794-.56 6.82-1.915 9.11-2.523 1.074.374 3.728 1.262 5.746 1.822 2.018.56 6.214.888 8.06.981.21-.42.574-1.794.35-3.924-.225-2.13-1.495-4.438-2.103-5.326-.747-.093-3-.224-6.026 0-3.784.28-12.894 2.103-14.435 2.663-1.542.56-4.696.56-5.677.841-.98.281-.98.001-1.471 1.333z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.246 24.775c-3.294.771-8.48 2.523-10.582 2.593-1.542.052-3.36-2.132-4.263-3.504a1.61 1.61 0 0 1-.134-.208c-.582-1.103 1.79-.964 5.099-1.824 3.503-.91 5.956-2.172 11.352-3.224 5.396-1.05 8.55-.42 9.6 0 1.052.42 1.963.982.421 3.645-1.542 2.662-5.256 8.198-12.263 8.479-5.607.224-8.41-1.776-9.11-2.803h4.064c2.242-.001 7.637-1.823 9.67-2.734 1.626-.73 3.62-.818 4.415-.771.163-.304.098-.911-1.472-.911-1.962 0-3.504.49-6.797 1.261z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvk);
export default __webpack_public_path__ + "static/media/TVK.628c3657d0a3f136364312a4cf8314d1.svg";
export { ForwardRef as ReactComponent };